import * as React from 'react';
import { SVGProps } from 'react';

const SvgAlergiesIntoleranceOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4a1 1 0 0 1 1 1v2.05l.006.114a1.05 1.05 0 0 0 1.652.743l.1-.079.778-.778a1 1 0 1 1 1.414 1.414l-.778.779a1.05 1.05 0 0 0 .609 1.744L16.9 11H19a1 1 0 1 1 0 2l-2.101.002-.063.004a1.05 1.05 0 0 0-.664 1.75l1.485 1.487a1 1 0 0 1-1.414 1.414l-1.486-1.485a1.05 1.05 0 0 0-1.744.61L13 16.95l.001.031L13 19a1 1 0 1 1-2 0v-2.1l-.006-.002v-.018A1.1 1.1 0 0 0 9.9 15.9c-.421 0-.756.356-.972.584l-1.878 1.88a1 1 0 0 1-1.414-1.414l2.192-2.193a1.05 1.05 0 0 0-.61-1.744L7.083 13H6a1 1 0 1 1 0-2h1.1l.064-.006a1.05 1.05 0 0 0 .664-1.75l-.07-.072a1 1 0 1 1 1.414-1.415l.07.071a1.05 1.05 0 0 0 1.744-.61L11 7.1V5a1 1 0 0 1 1-1Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgAlergiesIntoleranceOutlined;
